/*
 * @enum {string}
 */
export var ZipErrorCodes;
(function (ZipErrorCodes) {
    ZipErrorCodes["SUCCESS"] = "SUCCESS";
    ZipErrorCodes["NO_SOURCE_SPECIFIED"] = "NO_SOURCE_SPECIFIED";
    ZipErrorCodes["NO_DESTINATION_SPECIFIED"] = "NO_DESTINATION_SPECIFIED";
    ZipErrorCodes["NO_PASSWORD_SPECIFIED"] = "NO_PASSWORD_SPECIFIED";
    ZipErrorCodes["NO_PERMISSION"] = "NO_PERMISSION";
    ZipErrorCodes["NO_FILE_EXISTS"] = "NO_FILE_EXISTS";
    ZipErrorCodes["NO_FILE_VALID"] = "NO_FILE_VALID";
    ZipErrorCodes["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
})(ZipErrorCodes || (ZipErrorCodes = {}));
//# sourceMappingURL=definitions.js.map